<script setup>
// O arquivo escolhido para a próxima mensagem da conversa de teste (L-28): a
// foto em miniatura de 64 px, o PDF com o ícone e o nome, e o X de tirar no canto. O X aparece ao
// passar o mouse, e ao chegar nele pelo teclado; no celular, onde não há mouse para passar por cima
// (`hover: none`), fica sempre à vista. Clicar na miniatura abre o arquivo no visor. O X tem 24 px,
// o mínimo de alvo de toque.
//
// O nome do arquivo é o texto do botão (na foto, só para o leitor de tela): é por ele que a
// miniatura se anuncia, e é o que as duas telas conferem.
import { useI18n } from 'vue-i18n';

defineProps({
  // { nome, tipo: 'imagem' | 'pdf', url }, como sai de `escolherArquivos`.
  anexo: { type: Object, required: true },
});
const emit = defineEmits(['abrir', 'tirar']);
const { t } = useI18n();
</script>

<template>
  <div
    class="relative group shrink-0"
    :class="
      anexo.tipo === 'imagem' && anexo.url ? 'size-16' : 'h-16 min-w-0 max-w-52'
    "
    data-escolhido
  >
    <button
      type="button"
      class="flex items-center overflow-hidden transition-colors border rounded-xl size-full border-n-weak bg-n-alpha-1 text-n-slate-12 hover:border-n-strong"
      :title="anexo.nome"
      data-abrir
      @click="emit('abrir')"
    >
      <template v-if="anexo.tipo === 'imagem' && anexo.url">
        <img :src="anexo.url" alt="" class="object-cover size-full" />
        <span class="sr-only">{{ anexo.nome }}</span>
      </template>
      <span v-else class="flex items-center min-w-0 gap-2 pl-2 pr-3">
        <span
          class="flex items-center justify-center rounded-lg size-10 shrink-0 bg-n-ruby-3 text-n-ruby-11"
        >
          <i
            class="size-5"
            :class="
              anexo.tipo === 'pdf' ? 'i-lucide-file-text' : 'i-lucide-image'
            "
          />
        </span>
        <span class="text-xs font-medium text-left truncate">
          {{ anexo.nome }}
        </span>
      </span>
    </button>
    <button
      type="button"
      class="absolute flex items-center justify-center transition-opacity border rounded-full shadow-sm opacity-0 -top-2 -right-2 size-6 border-n-weak bg-n-solid-3 text-n-slate-12 hover:bg-n-solid-2 group-hover:opacity-100 focus-visible:opacity-100 [@media(hover:none)]:opacity-100"
      :aria-label="t('CONVERSA_DE_TESTE.FILES.REMOVE', { nome: anexo.nome })"
      data-tirar
      @click="emit('tirar')"
    >
      <i class="size-3.5 i-lucide-x" />
    </button>
  </div>
</template>
